<template>
  <!--  园区安防-->
  <div class="security">
    <div>
      <Title :info="waterTitle" />
      <div class="main">
        <!-- 照片 -->
        <div class="left">
          <img class="per-top" src="@/assets/perso_border.png" />
          <div class="ph">
            <div class="ph-center">
              <img src="@/assets/perso_ph.png" />
            </div>
          </div>
          <img class="per-bottom" src="@/assets/perso_border.png" />
        </div>
        <!-- 信息 -->
        <div class="right">
          <div class="per-total">
            <img src="@/assets/per_num.png" />
            <div>
              <span class="span-num"><i style="padding-right: 2px">54</i></span>
              <span class="unit">（人）</span>
              <p>人员总数</p>
            </div>
          </div>
          <div class="per-state z-per">
            <p><i>在岗</i></p>
            <p>
              <span class="span-num"><i style="padding-right: 2px">48</i> </span>
              <span class="unit">（人）</span>
            </p>
          </div>
          <div class="per-state">
            <p><i>离岗</i></p>
            <p>
              <span class="span-num"><i style="padding-right: 2px">12</i> </span
              ><span class="unit">（人）</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <Title :info="monitorTitle" />
    <ul class="monitor">
      <li>
        <span>监控1</span>
        <video src="../video/1.mp4" class="bg" muted autoplay controls loop></video>
      </li>
      <li>
        <span>监控1</span>
        <video src="../video/2.mp4" class="bg" muted autoplay controls loop></video>
      </li>
      <li>
        <span>监控1</span>
        <video src="../video/3.mp4" class="bg" muted autoplay controls loop></video>
      </li>
      <li>
        <span>监控1</span>
        <video src="../video/4.mp4" class="bg" muted autoplay controls loop></video>
      </li>
    </ul>
    <!-- 人员列表 -->
    <Title :info="personTitle" />
    <!-- 表头 -->
    <ul class="tab-head">
      <li>序号</li>
      <li>工号</li>
      <li>姓名</li>
      <li>是否在岗</li>
    </ul>
    <!-- 表体 -->
    <ul class="tab-body">
      <li v-for="(item, index) in personList" :key="index">
        <!-- 序号 -->
        <span v-if="index + 1 < 10">{{ `0${index + 1}` }}</span>
        <span v-else>{{ index + 1 }}</span>
        <span>{{ item.jobNum }}</span>
        <span>{{ item.name }}</span>
        <span style="color: #ffa710" v-if="item.isPost == 0">离岗</span>
        <span v-else>在岗</span>
      </li>
    </ul>

    <!-- 底部按钮 -->
    <ul class="bottom-btn">
      <li v-for="index in btnList.length" :key="index" @click="handleBtn(index)">
        <img class="icon" :src="require(`@/assets/sec_btn${index}.png`)">
        <img class="btn" src="../assets/sec_btn_back1.png">
        <p>{{btnList[index-1]}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import Title from "@/components/Title";

export default {
  name: "ParkSecurityView",
  components: {
    Title,
  },
  data() {
    return {
      waterTitle: {
        ico: require("./../assets/personnel_title.png"),
        text: "人员管理",
        english: "Personnel",
        width: 19,
        height: 19,
      },
      monitorTitle: {
        ico: require("./../assets/monitor.png"),
        text: "重点监控",
        english: "Focused monitoring",
        width: 19,
        height: 16,
      },
      personTitle: {
        ico: require("./../assets/person_list_title.png"),
        text: "人员列表",
        english: "List of people",
        width: 19,
        height: 16,
      },
      personList: [
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "0", // 是否在岗 0 离岗   1 在岗
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
        {
          jobNum: "000153",
          name: "李红玉",
          isPost: "1",
        },
      ],
      btnList:['电子围栏','巡检','视频监控','异常报警'],
      btnBackSe:require(`../assets/sec_btn_back2.png`), // 按钮背景图,已经选中
      btnBack:require(`../assets/sec_btn_back1.png`), // 按钮背景图,未选中
      activeInx:-1
    };
  },
  mounted() {
    window.parkSecurityViewCancel = this.parkSecurityViewCancel;
  },
  methods: {
    //取消三维的事件
    parkSecurityViewCancel(){
      let dom = document.querySelectorAll('.bottom-btn li')

      if(dom[0].className == 'active'){
        document.getElementById('iframe').contentWindow.MMAPI.endDrawRom()
      }else if(dom[1].className == 'active'){
        document.getElementById('iframe').contentWindow.MMAPI.stopFly()
      }else if(dom[2].className == 'active'){
        document.getElementById('iframe').contentWindow.MMAPI.district(5);
      }else if(dom[3].className == 'active'){
        document.getElementById('iframe').contentWindow.MMAPI.xfagin()
      }
      for(let i = 0; i < dom.length;i++){
        if(dom[i].className == 'active'){
          // dom[i].classList.remove('active')
          // console.log(dom[i].classList);
          dom[i].children[0].src = require(`../assets/sec_btn${i+1}.png`)
          dom[i].children[1].src = this.btnBack
          dom[i].className= ''
          break
        }
      }




    },
    oneCancel(num){

      switch (num) {
        case 0:
          console.log("s")
          document.getElementById('iframe').contentWindow.MMAPI.endDrawRom()

          break;
        case 1:
          console.log("ss")
          document.getElementById('iframe').contentWindow.MMAPI.stopFly()
          break;
        case 2:
          console.log("sss")
          document.getElementById('iframe').contentWindow.MMAPI.district(5);
          break;
        case 3:
          console.log("ssss")
          document.getElementById('iframe').contentWindow.MMAPI.xfagin()
          break;
      }
    },
    // 底部按钮点击方法
    handleBtn(index){
      let dom = document.querySelectorAll('.bottom-btn li')
      let dom1 = dom[index-1]
      if(dom1.className !== 'active'){
        dom1.children[0].src = require(`../assets/sec_btn${index}_back.png`)
        dom1.children[1].src = this.btnBackSe
        dom1.className= 'active'
      }else{
        dom1.children[0].src = require(`../assets/sec_btn${index}.png`)
        dom1.children[1].src = this.btnBack
        dom1.className= ''
      }
      // 清楚其他按钮,保持单选
      for(let i = 0; i< dom.length; i++){
        let imgNum = Number(i)+1
        if((index -1) != i){
          dom[i].children[0].src = require(`../assets/sec_btn${imgNum}.png`)
          dom[i].children[1].src = this.btnBack
          dom[i].className= ''
        }
      }
      //调用三维方法触发三维动画或者事件
      switch(index-1){
        case 0:
          if(dom1.className == 'active'){
            this.oneCancel(this.activeInx)
            this.activeInx = index-1

            document.getElementById('iframe').contentWindow.MMAPI.endDraw()
          }else{
            document.getElementById('iframe').contentWindow.MMAPI.endDrawRom()
          }
          break;
        case 1:
          if(dom1.className == 'active'){
            this.oneCancel(this.activeInx)
            this.activeInx = index-1

            document.getElementById('iframe').contentWindow.MMAPI.playFly()
          }else{
            document.getElementById('iframe').contentWindow.MMAPI.stopFly()
          }
          break;
        case 2:
          if(dom1.className == 'active'){
            this.oneCancel(this.activeInx)
            this.activeInx = index-1

            document.getElementById('iframe').contentWindow.MMAPI.equipCK(0)
          }else{
            document.getElementById('iframe').contentWindow.MMAPI.district(5);
          }
          break;
        case 3:
          if(dom1.className == 'active'){
            this.oneCancel(this.activeInx)
            this.activeInx = index-1

            document.getElementById('iframe').contentWindow.MMAPI.xfbj()
          }else{
            document.getElementById('iframe').contentWindow.MMAPI.xfagin()
          }
          break;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.security {
  width: 328px;
  margin: auto;

  .main {
    margin-top: 20vh * 0.0926;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .left {
    // 照片
    .ph {
      width: 155px;
      height: 170vh * 0.0926;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      .ph-center {
        margin: auto;
        width: 140.39px;
        height: 153.97vh * 0.0926;
        background: rgba(255, 255, 255, 0.2);
        display: flex;
        img {
          margin: auto;
        }
      }
    }
    .per-bottom {
      transform: rotate(-180deg);
    }
  }
  .right {
    .per-total {
      display: flex;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      img {
        width: 70px;
        margin-right: 12px;
      }
    }

    .span-num {
      font-size: 36px;
      font-weight: bold;
      background-image: -webkit-linear-gradient(bottom, #ffa710, #ffffff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .unit {
      font-size: 10px;
      color: rgba(255, 255, 255, 0.5);
    }
    // 在岗/离岗样式
    .per-state {
      width: 161.5px;
      height: 20vh * 0.0926;
      color: #fff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding-left: 12px;
      background-image: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.5) 30%,
        rgba(255, 255, 255, 0)
      );
      .span-num {
        font-size: 24px;
      }
    }
    .z-per {
      margin-top: 30vh * 0.0926;
      margin-bottom: 17vh * 0.0926;
    }
  }
  .monitor {
    color: rgba(255, 255, 255, 0.59);
    margin-top: 10vh * 0.0926;
    padding: 0 9px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 168.31px 168.31px;
    grid-template-rows: repeat(2, 121.59vh * 0.0926);
    li {
      background: url("./../assets/monitor-box.png") no-repeat;
      background-size: 100% 100%;
      width: 163.31px;
      height: 117vh * 0.0926;
      position: relative;
      &:nth-of-type(1) {
        margin-bottom: 10vh * 0.0926;
      }
      span {
        display: block;
        margin-left: 2px;
        margin-top: 2px;
      }
      .bg {
        background: url("./../assets/monitor-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 157px;
        height: 96vh*0.0926;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 3%;
        object-fit: fill;
      }
    }
  }
  // 人员列表表格样式
  .tab-head,
  .tab-body li {
    width: 341px;
    height: 26vh * 0.0926;
    line-height: 26vh * 0.0926;
    display: grid;
    grid-template-columns: 62px 101px 91px 88px;
    text-align: center;
  }
  .tab-head {
    font-size: 12px;
    color: #fff;
    margin-top: 20vh * 0.0926;
  }
  .tab-body {
    color: #b6b6b6;
    li {
      margin-bottom: 8vh * 0.0926;
      span:last-child {
        color: #fff;
      }
    }
    li:nth-child(2n) {
      background: rgba(255, 255, 255, 0.2);
    }
  }
  .bottom-btn{
    position: fixed;
    left: 506px;
    bottom: 67vh * 0.0926;
    display: flex;
    justify-content: space-between;
    width: 788px;
    li{
      width: 75px;
      position: relative;
      display: flex;
      flex-direction:column;
      align-items: center;
      cursor:pointer;
      .icon{
        position: absolute;
        bottom: 35vh * 0.0926;
      }
      p{
        font-size: 14px;
        color: #fff;
      }
    }
  }
}
</style>
